import React from 'react';
//Parts
import GridMain from './parts/grid.main';
import GridFactory from './parts/grid.factory';

class Grid extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.onLoaded && this.props.onLoaded();
    window.prefix = 'G';
  }

  //Methods
  getPageItens() {
    this.factory && this.factory.getPageItens();
  }

  haveItens() {
    return this.factory && this.factory.haveItens();
  }

  getSelectedItens() {
    return this.factory && this.factory.getSelectedItens();
  }

  setSelectedItem(index, value = true) {
    this.factory && this.factory.setSelectedItem(index, value);
  }

  setSelectedItens(indexArray) {
    this.factory && this.factory.setSelectedItens(indexArray);
  }

  getItem(index) {
    this.factory && this.factory.getItem(index);
  }

  checkAll(value = true) {
    this.factory && this.factory.checkAll(value);
  }

  getFilter() {
    this.factory && this.factory.getFilter();
  }

  getFilterGrid() {
    return this.factory && this.factory.getFilterGrid();
  }

  filterOnForm(array, filterByForm) {
    this.factory && this.factory.filterOnForm(array, filterByForm);
  }

  setParameter(key, value, withRefresh = true) {
    this.factory && this.factory.setParameter(key, value, withRefresh);
  }

  refresh() {
    this.factory && this.factory.refreshData();
  }

  clearFilters() {
    this.factory && this.factory.clearFilters();
  }

  clearColumn(column) {
    this.factory && this.factory.clearColumn(column);
  }

  render() {
    return (
      <GridFactory {...this.props} ref={(el) => (this.factory = el)}>
        <GridMain {...this.props} />
      </GridFactory>
    );
  }
}

export default Grid;
